import type { ReactNode } from "react";
import type { Role } from "../state/api.types";
import { useAuthHasRole } from "../state/hooks";

type RoleGateProps = {
  roles: Role[];
  children: ReactNode | ReactNode[];
};

export function RoleGate(props: RoleGateProps) {
  if (useAuthHasRole(...props.roles)) {
    return props.children;
  }
}
